import { getBattery, getDeviceInfo, getAppInfo, getDeviceID, getNetwork } from '@/libraries/device'
import { getDeviceIDs } from '@/libraries/headwind'

export default {
  namespaced: true,
  state: {
    now: Date.now(),
    battery: null,
    networkType: null,

    deviceID: null,

    // DeviceInfo
    model: null,
    system: null,
    webview: null,

    // AppInfo
    appURI: null,
    appBuild: null,
    appVersion: null,

    // Headwind
    isManaged: false,
    deviceIMEI: null,
    deviceSerial: null,
    deviceICCID: null,

    // BuildEnv
    envMode: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_RELEASE
  },
  mutations: {
    update (state, newSettings = {}) {
      for (const [key, value] of Object.entries(newSettings)) state[key] = value
    }
  },
  getters: {
    resolution: () => `${window.screen.width} x ${window.screen.height} (${(window.devicePixelRatio || 1).toFixed(2)} DPR)`,
    fullBuild: state => state.appURI ? `${state.appURI}:${state.appBuild}` : '',
    battery: state => state.battery || {},
    clientInfo: (state, getters) => ({
      id: state.deviceID,
      v: state.appVersion,
      s: state.model,
      r: getters.resolution
    })
  },
  actions: {
    load ({ commit }) {
      return Promise.all([
        getDeviceID().then(deviceID => commit('update', { deviceID })),
        getDeviceInfo().then(deviceInfo => commit('update', deviceInfo || {})),
        getAppInfo().then(appInfo => commit('update', appInfo || {})),
        getDeviceIDs().then(deviceIDs => {
          commit('update',
            deviceIDs
            ? { isManaged: true, deviceIMEI: deviceIDs.imei, deviceSerial: deviceIDs.serial, deviceICCID: deviceIDs.iccid }
            : { isManaged: false, deviceIMEI: null, deviceSerial: null, deviceICCID: null }
          )
        })
      ])
    },
    refresh ({ commit, state }) {
      const now = Date.now()
      commit('update', {
        now,
        networkType: getNetwork()
      })

      if (!state.battery || (now - state.battery?.timestamp) >= 30000) {
        getBattery().then(battery => { if (battery) commit('update', { battery }) })
      }
    }
  }
}
